import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillingDiscover = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 128,
	height: 86,
	viewBox: "0 0 128 86",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 5.37258 5.37258 0 12 0H116C122.627 0 128 5.37258 128 12V74C128 80.6274 122.627 86 116 86H12C5.37258 86 0 80.6274 0 74V12Z",
			fill: "#FFEFE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.9928 43.1636C75.0016 41.1002 74.228 39.0339 72.671 37.4768C71.1107 35.9165 69.0393 35.1435 66.9716 35.1559C66.9618 35.1559 66.9522 35.1552 66.9419 35.1552C62.4521 35.1552 58.8907 38.7157 58.8907 43.2068C58.8907 47.6536 62.496 51.2577 66.9419 51.2577C71.433 51.2577 74.9939 47.6966 74.9939 43.2068C74.9939 43.192 74.9928 43.1781 74.9928 43.1636Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.3936 46.6125C56.1902 47.8172 55.0795 48.2878 53.8832 48.3133C50.9687 48.2872 48.8259 46.1288 48.8259 43.0516C48.8259 41.5026 49.4124 40.233 50.3415 39.1485C51.2128 38.3213 52.3353 37.7869 53.626 37.7869C55.0193 37.7869 56.1037 38.2513 57.3415 39.49V35.9289C56.1039 35.3098 55.0191 35 53.626 35C51.6578 35.1407 49.8019 35.9359 48.3784 37.1847C47.9681 37.5539 47.575 37.9614 47.2416 38.4277C46.2018 39.7754 45.5734 41.4257 45.5734 43.207C45.5734 47.6966 49.1358 51.1029 53.6258 51.1029C53.6476 51.1029 53.6693 51.101 53.6905 51.1008C53.7206 51.1012 53.7504 51.1029 53.7804 51.1029C55.0189 51.1029 56.1037 50.7939 57.497 50.1745L57.3936 46.6125C57.3413 46.6647 57.4454 46.7133 57.3936 46.7628V46.6125Z",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.1582 37.2176L81.6517 45.8388L77.6257 35.6187H74.3746L80.7226 51.2574H82.4258L89.0838 35.6187H85.8327L85.1582 37.2176Z",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.323 42.4318V50.7936H98.6846H98.8388V48.3153H96.2068H93.4197V45.5289V44.1358H98.6846V41.5027H93.4197V38.2514H98.8388V35.6187H90.323V42.4318Z",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3363 35.6187H16V50.7936H20.3361C22.6583 50.7936 24.3612 50.1738 25.7547 49.0898C27.4577 47.6963 28.542 45.5291 28.542 43.2069C28.5422 38.7154 25.2901 35.6187 20.3363 35.6187ZM23.8972 47.0775C22.9681 47.8513 21.7294 48.3153 19.8712 48.3153H18.9421V38.2512H19.7162C21.5743 38.2512 22.8131 38.5608 23.7424 39.4895C24.8261 40.418 25.4457 41.8123 25.4457 43.2063C25.6006 44.5998 24.9813 46.1475 23.8972 47.0775Z",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8785 35.617H29.9366V50.7915H32.8785V35.617Z",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3099 41.5026C38.4521 40.8833 37.987 40.4184 37.987 39.6446C37.987 38.7155 38.9161 37.9414 40.1548 37.9414C41.0839 37.9414 41.858 38.2513 42.6323 39.1804L44.1811 37.1676C42.9419 36.0832 41.3942 35.4646 39.6908 35.4646C37.0579 35.4646 34.8901 37.3228 34.8901 39.7994C34.8901 41.9676 35.8201 42.8965 38.6067 43.9804C39.8454 44.4442 40.3101 44.5997 40.6204 44.9093C41.2385 45.2185 41.5488 45.8384 41.5488 46.457C41.5488 47.6959 40.6204 48.6252 39.226 48.6252C37.8311 48.6252 36.5935 47.8512 35.974 46.6122L34.1158 48.4704C35.51 50.4832 37.2132 51.4121 39.381 51.4121C42.4775 51.4121 44.6442 49.3993 44.6442 46.457C44.6446 43.8254 43.7164 42.7415 40.3099 41.5026Z",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.201 44.4444C109.522 43.9806 110.762 42.4316 110.762 40.1096C110.762 37.323 108.748 35.6187 105.342 35.6187H100.852V50.7936H103.794V44.7542H104.259L108.438 50.7936H112L107.201 44.4444ZM104.722 42.5862H103.794V37.9416H104.722C106.581 37.9416 107.665 38.7154 107.665 40.2649C107.665 41.8126 106.581 42.5862 104.722 42.5862Z",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61 86L128 66V74C128 80.6274 122.627 86 116 86H61Z",
			fill: "#FD6020"
		})
	]
});
export default SvgBillingDiscover;
